export default "__VITE_ASSET__DtWbiWu7__"